var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepwizard col-md-offset-3"},[_c('div',{staticClass:"stepwizard-row setup-panel"},_vm._l((_vm.steps),function(step){return _c('StepButton',{key:step.id,attrs:{"step":step}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }